import { GetState, SetState } from 'zustand';

export interface IAbTestData {
  customerProfilesEnumList: string[];
  name: string;
  selected: string;
}

interface IInitializeData {
  announcements: any[];
  features: {
    abTestData: IAbTestData[]
  };
  lastLoginTime: string;
  lastWebLoginTime: string;
}

export interface IInitializeApiSlice {
  currentInitializeApiData: IInitializeData,
  setCurrentInitializeApiData: (data: IInitializeData) => void;
  getCurrentInitializeApiData: () => IInitializeData,
}

const createInitializeApiSlice = (set: SetState<IInitializeApiSlice>, get: GetState<IInitializeApiSlice>) => ({
  currentInitializeApiData: {
    announcements: [],
    features: {
      abTestData: [],
    },
    lastLoginTime: '',
    lastWebLoginTime: '',
  },
  setCurrentInitializeApiData: (data: IInitializeData) => {
    set({ currentInitializeApiData: data });
  },
  getCurrentInitializeApiData: () => get().currentInitializeApiData,
});
export default createInitializeApiSlice;
